<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
  export default {
    name: 'App'
  }
</script>

<style lang="scss">
  @import url(https://fonts.googleapis.com/earlyaccess/notosanskr.css);
  @import "@/styles/Global.scss";
  html , body , ul{
    margin:0;
    padding:0;
    font-family: 'Noto Sans KR', sans-serif;
  }
  #app {
    /*font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    margin-top: 60px;*/
    height:100vh;
  }
</style>




// WEBPACK FOOTER //
// src/App.vue